import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useGlobal from '../../../store';
import { TARIFF_FEATURES, accessLevel, featureAllowed } from '../../../settings/tariff.features';
import './tariff.gate.scss';

const TariffGate = ({ feature, mode = 'redirect', children }) => {

  const navigate = useNavigate();
  const [ globalState ] = useGlobal();
  const { user_id, tariff } = globalState;
  const known = Object.prototype.hasOwnProperty.call(TARIFF_FEATURES, feature);
  const allowed = known && featureAllowed(accessLevel(tariff), feature);

  useEffect(() => {

    if (!user_id || mode !== 'redirect') return;

    if (!known || allowed) return;

    navigate(`/tariff-required?feature=${encodeURIComponent(feature)}`, { replace: true });

  }, [ user_id, mode, known, allowed, feature, navigate ]);

  if (!user_id || allowed) return children;

  if (mode === 'inline') {

    return (

      <div className = "tariff-inline">

        <p>{ TARIFF_FEATURES[ feature ].title }</p>

        <button
          type = "button"
          onClick = { () => navigate(`/tariff-required?feature=${encodeURIComponent(feature)}`) }
        >
          Подробнее
        </button>

      </div>

    );

  }

  return null;

};

export default TariffGate;
